module.exports = __webpack_public_path__ + "a724800161ac62624719410741a2a5fb.svg";